import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import CircularProgress from '@mui/material/CircularProgress';

import BackButton from '@ts-core/components/BackButton';

import AssignmentForm from '../../components/AssignmentForm';
import { AssignmentFormInput } from '../../types/form';
import { useAssignmentExercises, useAssignment, useAssignmentActions } from '../../hooks';

const EditAssignmentPage = () => {
  const intl = useIntl();
  const location = useLocation();

  const { courseId, assignmentId } = useParams<{ courseId: string; assignmentId: string }>();
  const { from } = queryString.parse(location.search) || {};
  const { exercises, loading: loadingExercises } = useAssignmentExercises({ courseId, assignmentId });
  const { assignment, loading: loadingAssignment } = useAssignment({ courseId, assignmentId });
  const { onUpdateAssignment, updateAssignmentLoading } = useAssignmentActions({ courseId });

  const handleUpdateAssignment = useCallback(
    (input: AssignmentFormInput) => {
      onUpdateAssignment(assignmentId, input);
    },
    [onUpdateAssignment, assignmentId]
  );

  if (loadingAssignment || loadingExercises) {
    return <CircularProgress />;
  }

  return (
    <>
      <BackButton
        title={intl.formatMessage({ id: 'assignment.editAssignment' })}
        subtitle={intl.formatMessage({ id: 'assignments' })}
        href={`/${courseId}/assignments${from ? `/${assignmentId}/${from}` : ''}`}
      />
      <AssignmentForm
        courseId={courseId}
        onSubmit={handleUpdateAssignment}
        submitting={updateAssignmentLoading}
        assignmentExercises={exercises}
        assignment={assignment}
      />
    </>
  );
};

export default EditAssignmentPage;
